/** Metadados Synap partilhados entre browser e Edge (sem PHI). */
export const LANGFUSE_SYNAP_METADATA_BASE = {
  synap_telemetry_layer: 'langfuse',
  synap_product: 'synap',
} as const

export const SENTRY_SYNAP_METADATA_BASE = {
  synap_telemetry_layer: 'sentry',
  synap_product: 'synap',
} as const

export const SYNAP_LANGFUSE_TRACE_HEADER = 'x-synap-langfuse-trace-id'
export const SYNAP_LANGFUSE_SESSION_HEADER = 'x-synap-langfuse-session-id'
export const SYNAP_LANGFUSE_PARENT_SPAN_HEADER = 'x-synap-langfuse-parent-span-id'
export const SYNAP_LANGFUSE_DOCTOR_HEADER = 'x-synap-langfuse-doctor-id'
export const SYNAP_CHUNK_ID_HEADER = 'x-synap-chunk-id'

export const ANAMNESIS_LANGFUSE_TRACE_STORAGE_PREFIX = 'synap-anamnesis-langfuse-trace:'

export type AnamnesisPipelineTimingMetrics = {
  upload_ms?: number
  stt_ms?: number
  diarization_ms?: number
  ai_ms?: number
  total_pipeline_ms?: number
  end_to_end_ms?: number
}

export type AnamnesisConsultationTelemetryContext = {
  consultation_id: string
  doctor_id?: string | null
  chunk_id?: string | null
  language?: string
  browser?: string
  device?: string
  offline_mode?: boolean
  fallback_mode?: string | null
  model_used?: string | null
}
